<template lang="pug">
Card.selections-card
  template(#header)
    .title {{ $t('selections.uploadMPRN.title') }}
  template(#content)
    .mprn-upload-wrapper
      FileUpload.mprn-upload(
        name="mprn"
        :auto="true" 
        accept="image/*,application/pdf"
        :multiple="false"
        :fileLimit="1"
        @upload="uploaded($event)"
        @error="uploaded($event)"
        url=""
      )
        template(#header="{ chooseCallback }")
          .files-button
            Button.mprn-button(@click="chooseCallback()" icon="pi pi-plus" :label="$t('selections.uploadMPRN.button')")
        template(#empty)
          .files-placeholder {{ $t('selections.uploadMPRN.placeholder') }}
</template>
<script lang="ts">
import { useSelections } from "@/store/selections";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import Card from "primevue/card";
import FileUpload, { FileUploadUploadEvent } from "primevue/fileupload";
import Button from "primevue/button";

export default defineComponent({
  name: "UploadMPRN",
  components: {
    Card,
    FileUpload,
    Button,
  },
  setup() {
    const selections = useSelections();
    const { mprn, mprnValid } = storeToRefs(selections);
    const { setFile } = selections;

    function uploaded(e: FileUploadUploadEvent) {
      setFile((e.files as File[])[0]);
    }

    return {
      mprn,
      mprnValid,
      uploaded,
    };
  },
});
</script>
<style scoped lang="scss">
.files-placeholder {
  font-size: 2rem;
  text-align: center;
  opacity: 0.5;
  cursor: default;
  position: relative;
  bottom: 2rem;
}
</style>
